module.exports = __webpack_public_path__ + "static/media/signup-banner.2241f5d7.png";